module.exports = __webpack_public_path__ + "img/avatar-12.CCo2_Vu9.abef2b9d.jpg";